/* eslint-disable no-unused-expressions */
/* eslint-disable */
!(function (global) {
  try {
    global.ACUITY_MODAL_INIT ||
      (function (global) {
        (global.ACUITY_MODAL_INIT = !0), initBar(), cleanBadHTML();
        var document = global.document,
          div = document.createElement("div");
        (div.innerHTML =
          '<div class="acuity-embed-modal" style="display: none;" role="dialog"><div class="acuity-modal-inner" tabindex="-1" role="document"><button class="acuity-modal-close" aria-label="Close" role="button" tabindex="0"><span aria-hidden="true">&times;</span></button><div id="acuity-modal-content" class="acuity-modal-content"><iframe id="acuity-modal-frame" src="" frameBorder="0" style="max-width: 900px;"></iframe></div><div class="acuity-modal-content-proxy"></div></div></div>'),
          document.body.appendChild(div.firstChild),
          (div.innerHTML =
            '<div id="acuity-modal" style="display: none;"></div>'),
          document.body.appendChild(div.firstChild),
          global.addEventListener("resize", resize),
          document.addEventListener("click", function (e) {
            var url,
              modal,
              frame,
              node = e.target;
            try {
              (!navigator ||
                !/iPad|iPhone|iPod/.test(navigator.userAgent) ||
                window.MSStream) &&
                global.innerWidth >= 280 &&
                global.innerHeight >= 280 &&
                (node = (function getAcuityNode(node) {
                  return /acuity-embed-button/.test(node.className)
                    ? node
                    : node.parentNode && getAcuityNode(node.parentNode);
                })(node)) &&
                ((lastClickedButton = node),
                (url = node.href),
                (modal = getModal()),
                (frame = getFrame()),
                modal &&
                  frame &&
                  url &&
                  (modal.open("#acuity-modal"),
                  (url = (function (url) {
                    var query,
                      result,
                      paramsToPassRegexes = [
                        /first_name/,
                        /last_name/,
                        /firstName/,
                        /lastName/,
                        /phone/,
                        /email/,
                        /certificate/,
                        /datetime/,
                        /field:[0-9]+?/,
                        /appointmentType/,
                        /appointmentTypeID/,
                        /calendarID/,
                      ],
                      parentParams =
                        // eslint-disable-next-line no-restricted-globals
                        ((query = location.search.substr(1)),
                        (result = {}),
                        query.split("&").forEach(function (part) {
                          if (part) {
                            var eq = (part = part.split("+").join(" ")).indexOf(
                                "="
                              ),
                              key = eq > -1 ? part.substr(0, eq) : part,
                              val =
                                eq > -1
                                  ? decodeURIComponent(part.substr(eq + 1))
                                  : "",
                              from = key.indexOf("[");
                            if (-1 == from)
                              result[decodeURIComponent(key)] = val;
                            else {
                              var to = key.indexOf("]"),
                                index = decodeURIComponent(
                                  key.substring(from + 1, to)
                                );
                              (key = decodeURIComponent(
                                key.substring(0, from)
                              )),
                                result[key] || (result[key] = []),
                                index
                                  ? (result[key][index] = val)
                                  : result[key].push(val);
                            }
                          }
                        }),
                        result),
                      newUrl = url;
                    for (var param in parentParams)
                      for (var i = 0; i < paramsToPassRegexes.length; i++) {
                        var regex = paramsToPassRegexes[i];
                        if (
                          param.match(regex) &&
                          -1 === url.indexOf(param + "=")
                        ) {
                          var val = parentParams[param],
                            varName = encodeURIComponent(param);
                          "object" == typeof val
                            ? ((varName += "[]"),
                              (val = val.join("&" + varName + "=")))
                            : (val = encodeURIComponent(val));
                          var urlParams = varName + "=" + val;
                          newUrl +=
                            (newUrl.indexOf("?") > -1 ? "&" : "?") + urlParams;
                        }
                      }
                    return newUrl;
                  })(url)),
                  frame.src != url && (frame.src = url)),
                e.preventDefault());
            } catch (e) {
              console.error(e);
            }
          }),
          document.addEventListener("DOMContentLoaded", initBar),
          getFrame().addEventListener("load", onLoad),
          window.addEventListener("message", function (event) {
            setTimeout(resize);
          });
      })(global);
  } catch (e) {}
  var modal = null,
    lastClickedButton = null,
    barInitialized = null;
  function initBar() {
    var bar = document.getElementsByClassName("acuity-booking-bar"),
      body = document.body;
    bar.length &&
      !barInitialized &&
      (window.top === window ||
        (global.innerWidth >= 480 && global.innerHeight >= 46)) &&
      ((body.className += " acuity-bar-visible"),
      body.appendChild(bar[0]),
      (barInitialized = !0),
      body.style &&
        window.getComputedStyle &&
        setTimeout(function () {
          var style = window.getComputedStyle(body);
          (body.style.position = style.position),
            (body.style.top = style.top),
            (bar[0].style.display = "block");
        }, 250));
  }
  function resize() {
    var modal = getModal(),
      frame = getFrame(),
      width = modal.dom.modal.offsetWidth,
      height = modal.dom.modal.offsetHeight,
      widthPadding = 24,
      heightPadding = 52,
      frameWidth = Math.min(width - widthPadding, 900),
      frameHeight = Math.min(height - heightPadding, 800);
    (width < 330 || height < 330) &&
      ((widthPadding = 10), (heightPadding = 38)),
      frame &&
        ((frame.width = frameWidth),
        (frame.height = frameHeight),
        frame.style &&
          ((frame.style.height = frameHeight + "px"),
          (frame.style.width = frameWidth + "px")));
  }
  function focus() {
    var modal = getModal();
    setTimeout(function () {
      focusNode(modal.dom.modalInner);
    }, 150);
  }
  function blur() {
    focusNode(lastClickedButton);
  }
  function onLoad() {
    var frame = getFrame();
    if (
      frame.src.indexOf("acuityscheduling.com") > -1 ||
      frame.src.indexOf("127.0.0.1") > -1 ||
      frame.src.indexOf(".as.me") > -1
    ) {
      postMessage(frame, "acuity:modal");
      var gaFn = !1;
      "undefined" != typeof ga
        ? // eslint-disable-next-line no-undef
          (gaFn = ga)
        : // eslint-disable-next-line no-undef
          "undefined" != typeof __gaTracker && (gaFn = __gaTracker),
        gaFn &&
          gaFn(function (tracker) {
            tracker || (tracker = gaFn.getAll()[0]);
            var cid = tracker.get("clientId");
            postMessage(frame, "gacid:" + cid);
          });
    }
  }
  function postMessage(frame, data) {
    void 0 !== frame &&
      "undefined" != typeof frame.contentWindow &&
      "function" == typeof frame.contentWindow.postMessage &&
      frame.contentWindow.postMessage(data, "*");
  }
  function getFrame() {
    return document.getElementById("acuity-modal-frame");
  }
  function getModal() {
    return (
      null === modal &&
        (modal = new VanillaModal["default"]({
          modal: ".acuity-embed-modal",
          modalInner: ".acuity-modal-inner",
          modalContent: ".acuity-modal-content-proxy",
          open: "[data-modal-open]",
          close: ".acuity-modal-close",
          page: "body",
          class: "acuity-modal-visible",
          loadClass: "acuity-modal",
          onBeforeOpen: resize,
          onOpen: focus,
          onClose: blur,
        })),
      modal
    );
  }
  function focusNode(node) {
    node && node.focus && node.focus();
  }
  function cleanBadHTML() {
    try {
      for (
        var bad = document.body.getElementsByClassName("acuity-embed-modal"),
          i = 0;
        i < bad.length;
        i++
      )
        bad[i].parentNode.removeChild(bad[i]);
    } catch (e) {}
  }
  var VanillaModal = {};
  !(function (exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: !0,
    });
    var _createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            (descriptor.enumerable = descriptor.enumerable || !1),
              (descriptor.configurable = !0),
              "value" in descriptor && (descriptor.writable = !0),
              Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          return (
            protoProps && defineProperties(Constructor.prototype, protoProps),
            staticProps && defineProperties(Constructor, staticProps),
            Constructor
          );
        };
      })(),
      _extends =
        Object.assign ||
        function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source)
              Object.prototype.hasOwnProperty.call(source, key) &&
                (target[key] = source[key]);
          }
          return target;
        },
      defaults = {
        modal: ".modal",
        modalInner: ".modal-inner",
        modalContent: ".modal-content",
        open: "[data-modal-open]",
        close: "[data-modal-close]",
        page: "body",
        class: "modal-visible",
        loadClass: "vanilla-modal",
        clickOutside: !0,
        closeKeys: [27],
        transitions: !0,
        transitionEnd: null,
        onBeforeOpen: null,
        onBeforeClose: null,
        onOpen: null,
        onClose: null,
      };
    function throwError(message) {
      console.error("VanillaModal: " + message);
    }
    function transitionEndVendorSniff() {
      var arr,
        callback,
        el = document.createElement("div");
      return ((arr = [
        {
          key: "transition",
          value: "transitionend",
        },
        {
          key: "OTransition",
          value: "otransitionend",
        },
        {
          key: "MozTransition",
          value: "transitionend",
        },
        {
          key: "WebkitTransition",
          value: "webkitTransitionEnd",
        },
      ]),
      (callback = function (_ref) {
        var key = _ref.key;
        return "undefined" != typeof el.style[key];
      }),
      function (key) {
        var filteredArray = arr.filter(callback);
        return filteredArray[0] ? filteredArray[0][key] : undefined;
      })("value");
    }
    function getNode(selector, parent) {
      var node = (parent || document).querySelector(selector);
      return node || throwError(selector + " not found in document."), node;
    }
    function addClass(el, className) {
      el instanceof HTMLElement || throwError("Not a valid HTML element."),
        el.setAttribute(
          "class",
          el.className
            .split(" ")
            .filter(function (cn) {
              return cn !== className;
            })
            .concat(className)
            .join(" ")
        );
    }
    function matches(e, selector) {
      for (
        var allMatches = (
            e.target.document || e.target.ownerDocument
          ).querySelectorAll(selector),
          i = 0;
        i < allMatches.length;
        i += 1
      )
        for (var node = e.target; node && node !== document.body; ) {
          if (node === allMatches[i]) return node;
          node = node.parentNode;
        }
      return null;
    }
    var VanillaModal = (function () {
      function VanillaModal(settings) {
        !(function (instance, Constructor) {
          if (!(instance instanceof Constructor))
            throw new TypeError("Cannot call a class as a function");
        })(this, VanillaModal),
          (this.isOpen = !1),
          (this.current = null),
          (this.isListening = !1),
          (this.settings = (function (settings) {
            return _extends({}, defaults, settings, {
              transitionEnd: transitionEndVendorSniff(),
            });
          })(settings)),
          (this.dom = this.getDomNodes()),
          (this.open = this.open.bind(this)),
          (this.close = this.close.bind(this)),
          (this.closeKeyHandler = this.closeKeyHandler.bind(this)),
          (this.outsideClickHandler = this.outsideClickHandler.bind(this)),
          (this.delegateOpen = this.delegateOpen.bind(this)),
          (this.delegateClose = this.delegateClose.bind(this)),
          (this.listen = this.listen.bind(this)),
          (this.destroy = this.destroy.bind(this)),
          this.addLoadedCssClass(),
          this.listen();
      }
      return (
        _createClass(VanillaModal, [
          {
            key: "getDomNodes",
            value: function () {
              var _settings = this.settings,
                modal = _settings.modal,
                page = _settings.page,
                modalInner = _settings.modalInner,
                modalContent = _settings.modalContent;
              return {
                modal: getNode(modal),
                page: getNode(page),
                modalInner: getNode(modalInner, getNode(modal)),
                modalContent: getNode(modalContent, getNode(modal)),
              };
            },
          },
          {
            key: "addLoadedCssClass",
            value: function () {
              addClass(this.dom.page, this.settings.loadClass);
            },
          },
          {
            key: "setOpenId",
            value: function (id) {
              this.dom.page.setAttribute(
                "data-current-modal",
                id || "anonymous"
              );
            },
          },
          {
            key: "removeOpenId",
            value: function () {
              this.dom.page.removeAttribute("data-current-modal");
            },
          },
          {
            key: "open",
            value: function (allMatches, e) {
              var page = this.dom.page,
                _settings2 = this.settings,
                onBeforeOpen = _settings2.onBeforeOpen,
                onOpen = _settings2.onOpen;
              this.current instanceof HTMLElement == !1
                ? (this.releaseNode(this.current),
                  (this.current = (function (e) {
                    return e && "string" == typeof e.hash
                      ? document.querySelector(e.hash)
                      : "string" == typeof e
                      ? document.querySelector(e)
                      : (throwError("No selector supplied to open()"), null);
                  })(allMatches)),
                  "function" == typeof onBeforeOpen &&
                    onBeforeOpen.call(this, e),
                  this.captureNode(this.current),
                  addClass(page, this.settings["class"]),
                  this.setOpenId(this.current.id),
                  (this.isOpen = !0),
                  "function" == typeof onOpen && onOpen.call(this, e))
                : throwError("VanillaModal target must exist on page.");
            },
          },
          {
            key: "detectTransition",
            value: function () {
              var modal = this.dom.modal,
                css = window.getComputedStyle(modal, null);
              return Boolean(
                [
                  "transitionDuration",
                  "oTransitionDuration",
                  "MozTransitionDuration",
                  "webkitTransitionDuration",
                ].filter(function (i) {
                  return "string" == typeof css[i] && parseFloat(css[i]) > 0;
                }).length
              );
            },
          },
          {
            key: "close",
            value: function (e) {
              var el,
                className,
                _settings3 = this.settings,
                transitions = _settings3.transitions,
                transitionEnd = _settings3.transitionEnd,
                onBeforeClose = _settings3.onBeforeClose,
                hasTransition = this.detectTransition();
              this.isOpen &&
                ((this.isOpen = !1),
                "function" == typeof onBeforeClose &&
                  onBeforeClose.call(this, e),
                (el = this.dom.page),
                (className = this.settings["class"]),
                el instanceof HTMLElement ||
                  throwError("Not a valid HTML element."),
                el.setAttribute(
                  "class",
                  el.className
                    .split(" ")
                    .filter(function (cn) {
                      return cn !== className;
                    })
                    .join(" ")
                ),
                transitions && transitionEnd && hasTransition
                  ? this.closeModalWithTransition(e)
                  : this.closeModal(e));
            },
          },
          {
            key: "closeModal",
            value: function (e) {
              var onClose = this.settings.onClose;
              this.removeOpenId(this.dom.page),
                this.releaseNode(this.current),
                (this.isOpen = !1),
                (this.current = null),
                "function" == typeof onClose && onClose.call(this, e);
            },
          },
          {
            key: "closeModalWithTransition",
            value: function (e) {
              var _this = this,
                modal = this.dom.modal,
                transitionEnd = this.settings.transitionEnd;
              modal.addEventListener(
                transitionEnd,
                function closeTransitionHandler() {
                  modal.removeEventListener(
                    transitionEnd,
                    closeTransitionHandler
                  ),
                    _this.closeModal(e);
                }
              );
            },
          },
          {
            key: "captureNode",
            value: function (node) {
              for (
                var modalContent = this.dom.modalContent;
                node.childNodes.length;

              )
                modalContent.appendChild(node.childNodes[0]);
            },
          },
          {
            key: "releaseNode",
            value: function (node) {
              for (
                var modalContent = this.dom.modalContent;
                modalContent.childNodes.length;

              )
                node.appendChild(modalContent.childNodes[0]);
            },
          },
          {
            key: "closeKeyHandler",
            value: function (e) {
              var arr,
                closeKeys = this.settings.closeKeys;
              (arr = closeKeys),
                "[object Array]" === Object.prototype.toString.call(arr) &&
                  arr.length &&
                  closeKeys.indexOf(e.which) > -1 &&
                  !0 === this.isOpen &&
                  (e.preventDefault(), this.close(e));
            },
          },
          {
            key: "outsideClickHandler",
            value: function (e) {
              var clickOutside = this.settings.clickOutside,
                modalInner = this.dom.modalInner;
              if (clickOutside) {
                for (var node = e.target; node && node !== document.body; ) {
                  if (node === modalInner) return;
                  node = node.parentNode;
                }
                this.close(e);
              }
            },
          },
          {
            key: "delegateOpen",
            value: function (e) {
              var matchedNode = matches(e, this.settings.open);
              matchedNode && (e.preventDefault(), this.open(matchedNode, e));
            },
          },
          {
            key: "delegateClose",
            value: function (e) {
              matches(e, this.settings.close) &&
                (e.preventDefault(), this.close(e));
            },
          },
          {
            key: "listen",
            value: function () {
              var modal = this.dom.modal;
              this.isListening
                ? throwError("Event listeners already applied.")
                : (modal.addEventListener(
                    "click",
                    this.outsideClickHandler,
                    !1
                  ),
                  document.addEventListener(
                    "keydown",
                    this.closeKeyHandler,
                    !1
                  ),
                  document.addEventListener("click", this.delegateOpen, !1),
                  document.addEventListener("click", this.delegateClose, !1),
                  (this.isListening = !0));
            },
          },
          {
            key: "destroy",
            value: function () {
              var modal = this.dom.modal;
              // eslint-disable-next-line no-unused-expressions
              this.isListening
                ? (this.close(),
                  modal.removeEventListener("click", this.outsideClickHandler),
                  document.removeEventListener("keydown", this.closeKeyHandler),
                  document.removeEventListener("click", this.delegateOpen),
                  document.removeEventListener("click", this.delegateClose),
                  (this.isListening = !1))
                : throwError("Event listeners already removed.");
            },
          },
        ]),
        VanillaModal
      );
    })();
    exports["default"] = VanillaModal;
  })(VanillaModal);
})(window);
(function () {
  try {
    if (document.getElementById("acuity-button-styles")) return;
    var c =
      'body.acuity-modal-visible{overflow:hidden}body.acuity-modal-visible .acuity-embed-modal iframe{visibility:visible!important;opacity:1!important;margin:0}.acuity-embed-modal{display:block!important;position:fixed;content:"";top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);z-index:-10;opacity:0;-webkit-transition:opacity .2s,z-index 0s .2s;-o-transition:opacity .2s,z-index 0s .2s;transition:opacity .2s,z-index 0s .2s;text-align:center;overflow:hidden;overflow-y:auto;white-space:nowrap;-webkit-overflow-scrolling:touch;visibility:hidden}.acuity-modal .acuity-embed-modal>*{display:inline-block;white-space:normal;vertical-align:middle;text-align:left}.acuity-modal .acuity-embed-modal:before{display:inline-block;overflow:hidden;width:0;height:100%;vertical-align:middle;content:""}.acuity-modal.acuity-modal-visible .acuity-embed-modal{visibility:visible;z-index:2000001;opacity:1;-webkit-transition:opacity .2s;-o-transition:opacity .2s;transition:opacity .2s}.acuity-modal.acuity-modal-visible .acuity-modal-inner{z-index:1;opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);-webkit-transition:opacity .2s,-webkit-transform .2s;transition:opacity .2s,-webkit-transform .2s;-o-transition:opacity .2s,transform .2s;transition:opacity .2s,transform .2s;transition:opacity .2s,transform .2s,-webkit-transform .2s}.acuity-modal-inner{padding:26px 6.5px 6.5px;position:relative;max-width:98%;max-height:98%;overflow:hidden;overflow-y:auto;background:#fff;z-index:-1;opacity:0;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transition:opacity .2s,z-index 0s .2s,-webkit-transform .2s;transition:opacity .2s,z-index 0s .2s,-webkit-transform .2s;-o-transition:opacity .2s,transform .2s,z-index 0s .2s;transition:opacity .2s,transform .2s,z-index 0s .2s;transition:opacity .2s,transform .2s,z-index 0s .2s,-webkit-transform .2s}.acuity-modal-content,.acuity-modal-inner{-webkit-box-sizing:content-box;box-sizing:content-box}.acuity-modal-content{-webkit-overflow-scrolling:touch;overflow:auto;line-height:22px;font-size:15px}.acuity-modal-close{position:absolute;z-index:2;right:0;top:0;height:28px;width:28px;line-height:28px;cursor:pointer;text-align:center;color:#5fb8b9;font-size:28px;font-weight:700;background:rgba(0,0,0,0);border:0;padding:0}.acuity-embed-button,a.acuity-embed-button,a.acuity-embed-button:link{color:#fff} inset;box-shadow:inset 0 -2px 0 rgba(0,0,0,.15);border-radius:4px;text-decoration:none;display:inline-block}.acuity-embed-button:active,.acuity-embed-button:focus,.acuity-embed-button:hover,.acuity-embed-button:visited{color:#fff}.acuity-embed-button:hover{-webkit-filter:brightness(112%);filter:brightness(112%)}';
    var s = document.createElement("style");
    s.type = "text/css";
    s.id = "acuity-button-styles";
    s.styleSheet
      ? (s.styleSheet.cssText = c)
      : s.appendChild(document.createTextNode(c));
    var n = document.getElementsByTagName("script")[0];
    n.parentNode.insertBefore(s, n);
  } catch (e) {}
})();
